import { copayDayStr } from './copayDayStr';

export function getDurationDays(startDate, endDate) {
  return 'Day ' + copayDayStr(startDate) + ' to ' + copayDayStr(endDate);
}
